/**
 * This composable exposes the page source from the route query or the route
 * base name.
 */
export default function usePageSource() {
  const route = useRoute()
  const { routeBaseName } = useBaseName()

  const pageSource = computed(() => {
    return route.query?.pageSource as string || routeBaseName.value as string
  })

  return {
    pageSource,
  }
}
